import * as tslib_1 from "tslib";
import * as React from 'react';
import Main from '../../layout/Main';
import SearchApi from '../../services/SearchApi';
import SearchResultsTable from './SearchResultsTable';
import { grey700 } from 'material-ui/styles/colors';
import TaskDialog from '../../components/TaskDialog';
import BusyIndicator from '../../components/BusyIndicator';
var styles = {
    title: {
        margin: '1rem',
        marginBottom: 0,
        color: grey700
    },
    input: {
        margin: "1rem",
        lineHeight: "30px",
        fontSize: '13px',
        padding: ".25rem .5rem",
        borderRadius: "3px",
        border: "1px solid #ddd",
        width: '96%'
    },
    resultsContainer: {
        padding: '1rem'
    },
    message: {
        display: 'flex',
        flexDirection: 'row',
        color: grey700,
        justifyContent: 'center'
    }
};
var SearchPage = /** @class */ (function (_super) {
    tslib_1.__extends(SearchPage, _super);
    function SearchPage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            searchText: '',
            busy: false,
            results: [],
            taskID: 0,
            isTaskDialogOpened: false,
        };
        _this.handleSearchTextChange = function (e) {
            e.preventDefault();
            _this.setState({ searchText: e.target.value, results: [] });
        };
        _this.search = function (e) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var searchText, results;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        e.preventDefault();
                        if (this.state.busy) {
                            return [2 /*return*/];
                        }
                        searchText = this.state.searchText;
                        if (searchText.length === 0) {
                            this.setState({ results: [] });
                            return [2 /*return*/];
                        }
                        if (searchText.length < 3) {
                            return [2 /*return*/];
                        }
                        this.setState({ busy: true });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, , 3, 4]);
                        return [4 /*yield*/, SearchApi.search(searchText)];
                    case 2:
                        results = _a.sent();
                        this.setState({ results: results });
                        return [3 /*break*/, 4];
                    case 3:
                        this.setState({ busy: false });
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        _this.selectItem = function (item) {
            _this.setState({ taskID: item.taskID, isTaskDialogOpened: true });
        };
        _this.closeTaskDialog = function () {
            _this.setState({ isTaskDialogOpened: false });
        };
        _this.getResultComponent = function () {
            if (_this.state.searchText.length < 3 || _this.state.results.length === 0) {
                return null;
            }
            return React.createElement(SearchResultsTable, { results: _this.state.results, selectItem: _this.selectItem });
        };
        return _this;
    }
    SearchPage.prototype.render = function () {
        return (React.createElement(Main, null,
            React.createElement("form", { onSubmit: this.search },
                React.createElement("input", { onChange: this.handleSearchTextChange, style: styles.input, placeholder: "Keres\u00E9s a feladatok k\u00F6z\u00F6tt..." })),
            React.createElement("section", { style: styles.resultsContainer },
                React.createElement(BusyIndicator, { size: 20, active: this.state.busy }, this.getResultComponent())),
            React.createElement(TaskDialog, { isOpen: this.state.isTaskDialogOpened, taskId: this.state.taskID, onClose: this.closeTaskDialog })));
    };
    return SearchPage;
}(React.Component));
export default SearchPage;



//////////////////
// WEBPACK FOOTER
// ./src/pages/search/SearchPage.tsx
// module id = 810
// module chunks = 0